//icone utilizzate OUTLINE https://react-icons.github.io/react-icons/icons?name=hi2
import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, Outlet, Navigate, createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";
import { Home } from "./pages/Home";
import Login from "./pages/Login";
import { AppLayout } from "./pages/AppLayout";
import { Clienti } from "./pages/Clienti";
import { F24 } from "./pages/F24";
import { Uniemens } from "./pages/Uniemens";
import { Parcellazione } from "./pages/Parcellazione";
import { Newsletter } from "./pages/Newsletter";

import { LicenseInfo } from "@mui/x-data-grid-pro";
import { DettaglioClienti } from "./pages/Clienti/DettaglioClienti";
import { DashboardClienti } from "./pages/Clienti/DashboardClienti";
import  RequireAuth  from "./components/RequireAuth";

import { TransitionProvider } from "./components/DataGrid/TransitionContext";
import TransitionComponent from "./pages/Transition";
import { Referenti } from "./pages/Referenti";
import { Statistiche } from "./pages/Statistiche";
import {SetPassword } from "./pages/SetPassword";
import { Anagrafiche } from "./pages/Anagrafiche";
import { knowAcces } from "./utils/utils";
LicenseInfo.setLicenseKey(
  "d7d4e9b8c968c794c9b739b472716835Tz0xMjM5OTQsRT0xNzk5NDUyNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI="
);

const AdministrationPageGuard = ({ children }) => {
  const administrationOnly = knowAcces(["amministrazione"]) && !knowAcces([
    "admin", "team_leader", "paghe", "assunzioni", "segreteria", "f24", "consulente",
  ]);
  return administrationOnly ? <Navigate to="/Clienti" replace /> : children;
};

function App() {
  const [screenSize, getDimension] = useState(window.innerWidth);
  const setDimension = () => {
    getDimension(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", setDimension);
}, [screenSize]);

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Login />} />
      <Route path="/setPassword" element={<SetPassword />} />
      <Route element={<RequireAuth />} >
        <Route path="/" element={<AppLayout />}>
          <Route path="/Home" element={<AdministrationPageGuard><Home screenSize={screenSize} /></AdministrationPageGuard>} />
          <Route path="/Clienti" element={<Clienti screenSize={screenSize} />} />
          <Route path="/DettaglioClienti" element={<DettaglioClienti screenSize={screenSize} />} />
          <Route path="/F24" element={<AdministrationPageGuard><F24 screenSize={screenSize} /></AdministrationPageGuard>} />
          <Route path="/Uniemens" element={<AdministrationPageGuard><Uniemens screenSize={screenSize} /></AdministrationPageGuard>} />
          <Route path="/Parcellazione" element={<Parcellazione screenSize={screenSize} />} />
          <Route path="/Newsletter" element={<AdministrationPageGuard><Newsletter screenSize={screenSize} /></AdministrationPageGuard>} />
          <Route path="/Referenti" element={<AdministrationPageGuard><Referenti screenSize={screenSize} /></AdministrationPageGuard>} />
          <Route path="/Statistiche" element={<AdministrationPageGuard><Statistiche screenSize={screenSize} /></AdministrationPageGuard>} />
          <Route path="/Anagrafiche" element={<AdministrationPageGuard><Anagrafiche screenSize={screenSize} /></AdministrationPageGuard>} />
        </Route>
      </Route>
    </>
  ),
  { basename: process.env.REACT_APP_BASENAME || '/' }
)


  return (
    <>
      <TransitionProvider>
  <RouterProvider router={router} />
  </TransitionProvider>
    </>
  );
}

export default App;

/*
const router = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/Clienti",
    element: <Clienti  />,
    loader:aziendeLoader
  },
  {
    path: "/Home",
    element: <Home  />,
  },
  {
    path: "/DettaglioClienti",
    element: <DettaglioClienti  />,
  },
  {
    path: "/F24",
    element: <F24 />,
  },
]

*/
